import { FunctionComponent, useCallback, useState } from "react";
import { IconButton } from "@ui-kit/IconButton/IconButton";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { ShareIcon } from "@icons/ShareIcon";
import { Modal, ModalContent, ModalTitle } from "@ui-kit/Modal/Modal";
import { useTranslation } from "react-i18next";
import { ShareHome } from "./ShareHome";
import { ShareHelp } from "./ShareHelp";
import { ShareEmail } from "./ShareEmail";
import { ShareSms } from "./ShareSms";
import { ChevronLeftIcon } from "@icons/ChevronLeftIcon";

import "./SharePlan.css";

const SharePlan: FunctionComponent = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const handleSharePlan = useCallback(() => {
    setIsOpen(true);
  }, []);
  const [view, setView] = useState<"home" | "sms" | "email" | "help">("home");

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setView("home");
  }, [setIsOpen, setView]);

  const handleBackPress = useCallback(() => {
    setView("home");
  }, [setView]);

  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleClose}
        width={390}
        segmentedFooter={true}>
        <ModalTitle>
          <div className="share-plan-title-container">
            {view !== "home" && (
              <IconButton
                type="flat"
                icon={<ChevronLeftIcon size={18} color={colors.neutral700} />}
                onPress={handleBackPress}
              />
            )}
            {view === "home" && t("screens.planShare.sharePlanTitle")}
            {view === "sms" && t("screens.planShare.smsPlanTitle")}
            {view === "email" && t("screens.planShare.emailPlanTitle")}
            {view === "help" && t("screens.planShare.helpPlanTitle")}
          </div>
        </ModalTitle>
        <ModalContent>
          <div className="share-plan-content">
            {view === "home" && (
              <ShareHome setView={setView} onClose={handleClose} />
            )}
            {view === "sms" && <ShareSms onClose={handleClose} />}
            {view === "email" && <ShareEmail onClose={handleClose} />}
            {view === "help" && <ShareHelp onClose={handleClose} />}
          </div>
        </ModalContent>
      </Modal>

      <IconButton
        onPress={handleSharePlan}
        icon={<ShareIcon size={18} color={colors.neutral700} />}
      />
    </>
  );
};

export { SharePlan };
